import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)


// Add Class When Scrolled To Screen.
// Usage: add class js-add-class-when-in-screen,
//    add attribute: data-add-class="className",
//    to add each time when scrolled add attribute: add-class-repeat
document.querySelectorAll('.js-add-class-when-in-screen').forEach(function (el) {
  ScrollTrigger.create({
    trigger: el,
    start: "top bottom-=30px", // el top, screen bottom
    once: el.getAttribute('add-class-repeat'),
    onEnter: () => {
      let addClass = el.getAttribute('data-add-class') ? el.getAttribute('data-add-class') : 'js-in-screen';
      el.classList.add(addClass)
    }
  });
})


// draw line hr
document.querySelectorAll('hr').forEach(function (el) {
  ScrollTrigger.create({
    trigger: el,
    start: "top bottom-=30px", // el top, screen bottom
    once: true,
    onEnter: () => {
      let addClass = 'in-screen'
      el.classList.add(addClass)
    }
  });
})
